import { sortByPriority } from "@/lib";

export interface Group<T> {
	label: string;
	keys?: string[];
	count: number;
	items: T[];
}

export default function useGroupedList<T>(
	list: T[],
	getKey: (item: T) => string[],
	priorityList?: string[],
): Group<T>[] {
	const groupMap = list.reduce(
		(acc, item) => {
			const [label, ...keys] = getKey(item);
			if (!acc[label]) {
				acc[label] = {
					keys,
					items: [],
				};
			}
			acc[label].items.push(item);
			return acc;
		},
		{} as Record<string, Pick<Group<T>, "items" | "keys">>,
	);

	const groupedList = Object.entries(groupMap).map(
		([label, { items, keys }]) => ({
			keys,
			label,
			items,
			count: items.length,
		}),
	);
	return priorityList
		? sortByPriority(
				groupedList,
				(x) => (x.keys && x.keys?.length > 0 ? x.keys : [x.label]),
				priorityList,
			)
		: groupedList;
}
